import React, { createRef, useState } from 'react';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Typography, Select, Space } from 'antd';
import { Flex } from 'rebass';
import styled from 'styled-components';
import { PAGES } from '../../../../components/main/paths';
import { useHistory } from 'react-router-dom';

const StyledSearchContainer = styled(Flex).attrs(({ visible = false }) => ({ visible }))`
  z-index: 99;
  align-items: center;
  position: absolute;
  background-color: white;
  left: 8px;
  right: 8px;
  top: 0;
  bottom: 0;
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1);
  transform: ${({ visible }) => `translate3d(0, ${visible ? '0%' : '-100%'}, 0)`};
`;

export function Search() {
  const ref = createRef();
  const [visible, setVisible] = useState(false);
  const history = useHistory();

  return (
    <Flex ml="auto">
      <StyledSearchContainer visible={visible}>
        <Flex width={40} justifyContent="center">
          <SearchOutlined />
        </Flex>
        <Select
          ref={ref}
          value={null}
          allowClear
          showSearch
          autoFocus
          optionFilterProp="label"
          defaultActiveFirstOption={false}
          showArrow={false}
          notFoundContent={null}
          bordered={false}
          placeholder="Search for a page"
          onInputKeyDown={() => setVisible(true)}
          style={{ flex: 'auto' }}
          onChange={path => {
            setVisible(false);
            history.push(path);
          }}
        >
          {PAGES.map(({ key, name, pages }) => (
            <Select.OptGroup key={key} label={name}>
              {pages.map(page => (
                <Select.Option key={page.key} label={page.name} value={page.path}>
                  <Space align="center" size={12}>
                    {/* {icon && React.cloneElement(icon, { style: { fontSize: 20, color: colors.teal } })} */}
                    <Space size={2} direction="vertical">
                      <Typography.Text>{page.name}</Typography.Text>
                      <Typography.Text type="secondary">{page.path}</Typography.Text>
                    </Space>
                  </Space>
                </Select.Option>
              ))}
            </Select.OptGroup>
          ))}
        </Select>
        <Button onClick={() => setVisible(false)} type="text" shape="circle" icon={<CloseOutlined />} />
      </StyledSearchContainer>
      <Button
        shape="circle"
        icon={<SearchOutlined />}
        type="dashed"
        onClick={() => {
          setVisible(true);
          ref.current.focus();
        }}
      />
    </Flex>
  );
}
